import {
  CLOSEDMANUALOTPREQUESTLIST_SUCCESS,
  CLOSEDMANUALOTPREQUESTLIST_FAILED,
  RESET_CLOSEDMANUALOTPREQUESTLIST,
  LOADING_CLOSEDMANUALOTPREQUESTLIST,
  NETWORK_ERROR_CLOSEDMANUALOTPREQUESTLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetClosedManualOtpRequestList = () => {
  return { type: RESET_CLOSEDMANUALOTPREQUESTLIST };
};

const closedManualOtpRequestList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_CLOSEDMANUALOTPREQUESTLIST });
    await partnerServices
      .post("closedManualOtpRequest", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.status) {
          case 200:
            dispatch(closedManualOtpRequestListsuccess(res.data));
            break;
          default:
            dispatch(closedManualOtpRequestListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_CLOSEDMANUALOTPREQUESTLIST,
          payload: err,
        });
      });
  };
function closedManualOtpRequestListsuccess(data) {
  return {
    type: CLOSEDMANUALOTPREQUESTLIST_SUCCESS,
    payload: data,
  };
}
function closedManualOtpRequestListFailed(data) {
  return {
    type: CLOSEDMANUALOTPREQUESTLIST_FAILED,
    payload: data,
  };
}

export { closedManualOtpRequestList, resetClosedManualOtpRequestList };
